import type { DeepPartial } from '@apollo/client/utilities';

import type {
  AmericanFootballFixture,
  BaseballFixture,
  BasketballFixture,
  DartsFixture,
  EsportsFixture,
  FootballFixture,
  HandballFixture,
  IceHockeyFixture,
  SnookerFixture,
  TableTennisFixture,
  TennisMatch,
  VolleyballFixture
} from '@swf/generated/graphql/scoreboards/schemas';

import { EventTypeId } from '../types/eventType';

export type LiveData =
  | DeepPartial<AmericanFootballFixture>
  | DeepPartial<BaseballFixture>
  | DeepPartial<BasketballFixture>
  | DeepPartial<DartsFixture>
  | DeepPartial<EsportsFixture>
  | DeepPartial<FootballFixture>
  | DeepPartial<HandballFixture>
  | DeepPartial<IceHockeyFixture>
  | DeepPartial<SnookerFixture>
  | DeepPartial<TableTennisFixture>
  | DeepPartial<TennisMatch>;

export const getIsAmericanFootballLiveData = (
  eventTypeId: EventTypeId,
  _data: LiveData
): _data is AmericanFootballFixture => eventTypeId === EventTypeId.AMERICAN_FOOTBALL;

export const getIsBaseballLiveData = (
  eventTypeId: EventTypeId,
  _data: LiveData
): _data is BaseballFixture => eventTypeId === EventTypeId.BASEBALL;

export const getIsBasketballLiveData = (
  eventTypeId: EventTypeId,
  _data: LiveData
): _data is BasketballFixture => eventTypeId === EventTypeId.BASKETBALL;

export const getIsHandballLiveData = (
  eventTypeId: EventTypeId,
  _data: LiveData
): _data is HandballFixture => eventTypeId === EventTypeId.HANDBALL;

export const getIsDartsLiveData = (
  eventTypeId: EventTypeId,
  _data: LiveData
): _data is DartsFixture => eventTypeId === EventTypeId.DARTS;

export const getIsESportsLiveData = (
  eventTypeId: EventTypeId,
  _data: LiveData
): _data is EsportsFixture => eventTypeId === EventTypeId.E_SPORTS;

export const getIsFootballLiveData = (
  eventTypeId: EventTypeId,
  _data: LiveData
): _data is FootballFixture => eventTypeId === EventTypeId.SOCCER;

export const getIsIceHockeyLiveData = (
  eventTypeId: EventTypeId,
  _data: LiveData
): _data is IceHockeyFixture => eventTypeId === EventTypeId.ICE_HOCKEY;

export const getIsSnookerLiveData = (
  eventTypeId: EventTypeId,
  _data: LiveData
): _data is SnookerFixture => eventTypeId === EventTypeId.SNOOKER;

export const getIsTableTennisLiveData = (
  eventTypeId: EventTypeId,
  _data: LiveData
): _data is TableTennisFixture => eventTypeId === EventTypeId.TABLE_TENNIS;

export const getIsTennisLiveData = (
  eventTypeId: EventTypeId,
  _data: LiveData
): _data is TennisMatch => eventTypeId === EventTypeId.TENNIS;

export const getIsVolleyballLiveData = (
  eventTypeId: EventTypeId,
  _data: LiveData
): _data is VolleyballFixture => eventTypeId === EventTypeId.VOLLEYBALL;
